import { VoucherCard } from 'components/SpaceBooking/types';
import { useEffect, useState } from 'react';

interface Props {
    voucher: VoucherCard;
    newValue?: number;
    initialValue?: number;
    preview?: boolean;
    onChange?: (newValue: number) => void;
}

export const VoucherCardValueGrid = ({ voucher, initialValue = 0, newValue, preview, onChange }: Props) => {
    const [value, _setValue] = useState(initialValue || voucher.value);
    const oldValue = initialValue || voucher.value;

    const setValue = (newValue: number) => {
        _setValue(newValue);
        if (value !== newValue) onChange?.(newValue);
    };

    useEffect(() => {
        if (newValue) setValue(newValue);
        else setValue(oldValue);
    }, [newValue]);

    return voucher.units ? (
        <div className="tw-flex tw-gap-1">
            {Array(Number(voucher.units))
                .fill(true)
                .map((_, i) => (
                    <div className="tw-cols-span-1 tw-w-fit" key={i}>
                        <div
                            role={!preview ? 'button' : undefined}
                            tabIndex={!preview ? 0 : -1}
                            aria-pressed={!preview ? value >= i + 1 : undefined}
                            className={`tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-2xl tw-transition-colors tw-duration-300 ${
                                preview ? 'tw-cursor-default' : 'tw-cursor-pointer'
                            }`}
                            style={{
                                height: 55,
                                width: 55,
                                backgroundColor:
                                    i >= oldValue && i < value ? '#FDF7E6' : value >= i + 1 ? '#DAFBE8' : '#F1F3F5',
                                color: i >= oldValue && i < value ? '#f6993f' : value >= i + 1 ? '#38c172' : '#11181C',
                                fontSize: '0.875rem',
                                userSelect: 'none'
                            }}
                            onClick={() => {
                                if (!preview) {
                                    setValue(i + 1);
                                }
                            }}
                            onKeyDown={(event) => {
                                if (!preview && (event.key === 'Enter' || event.key === ' ')) {
                                    event.preventDefault();
                                    setValue(i + 1);
                                }
                            }}
                        >
                            <small className="tw-text-[8px] tw-text-accents-7">
                                {Intl.NumberFormat('de-DE', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }).format(voucher.price / voucher.units)}{' '}
                                €
                            </small>
                            <p className="tw-m-0">{i + 1}</p>
                            <small className="tw-text-[8px] tw-text-accents-8">{voucher.unit_size * 15} Min</small>
                        </div>
                    </div>
                ))}
        </div>
    ) : null;
};
